/**
 * Maps the current authenticated app path to a walkthrough tour id (see TOURS in ./tours).
 * Used by the header "?" control so each major screen can replay its guided tour.
 */
export function tourIdForPathname(pathname) {
  const p = pathname || "";
  if (/\/(admin|operator)\/manual-queries\/?(\?.*)?$/i.test(p)) return "manual-query";
  if (/\/(admin|operator)\/manual-query\//i.test(p)) return "manual-query-detail";
  if (/\/(admin|operator)\/(incomplete-queries|all-quotes)/i.test(p)) return "email-queries";
  if (/\/(admin|operator)\/newQuotePage\//i.test(p)) return "quote-detail";
  if (/\/(admin|operator)\/complete-quote\//i.test(p)) return "conversation";
  if (/\/(admin|operator)\/quotes-airline-response/i.test(p)) return "rate-request";
  if (/\/(admin|operator)\/dashboard\/?(\?.*)?$/i.test(p)) return "dashboard";
  return "onboarding";
}
